module.exports = __webpack_public_path__ + "static/media/firstPageDisabled.7fc6ff6f.svg";